import { Input } from 'antd';
import React from 'react';
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@chakra-ui/react';

type Props = {
    orderInstructions: any,
    setOrderInstructions: Function,
}

const OrderInstructions = ({ orderInstructions, setOrderInstructions }: Props) => {
    return (
        <div className="bg-neutral-50 px-3 py-2 rounded-lg md:block border border-solid border-neutral-300">
            <Accordion
                allowToggle
                p={0}
                className="w-full"
            >
                <AccordionItem>
                    <AccordionButton p={0} py={2}>
                        <label className="text-sm text-neutral-600 font-semibold">Order Instructions</label>
                        <AccordionIcon fontSize={20} fontWeight={700} />
                    </AccordionButton>
                    <AccordionPanel pb={4}>
                        <div className="flex flex-col gap-4 pt-2">
                            {/* Instructions TextArea */}
                            <div className="flex flex-col gap-2">
                                <Input.TextArea
                                    placeholder="Enter instructions"
                                    rows={4}
                                    className="resize-none"
                                    value={orderInstructions?.instructions}
                                    onChange={(e) => setOrderInstructions({
                                        ...orderInstructions,
                                        instructions: e?.target?.value
                                    })}
                                />
                            </div>
                        </div>
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default OrderInstructions;